import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import Header from "../../../COMPONENTS/header/Header";
import StatBox from "../../../COMPONENTS/StatBox";
import axios from "axios";
import "./searchHistory.css";
import AuthContext from "../../../CONTEXT/AuthProvider";

function SearchHistory() {
  const [searchHistory, setSearchHistory] = useState();
  const [countSuccessfulSearch, setCountSuccessfulSearch] = useState();
  const [countFailedSearch, setCountFailedSearch] = useState();

  const { auth } = useContext(AuthContext);
  const subscribername = auth.subscriberName;
  const staff = auth.staff;
  const accessToken = auth.accessToken;

  useEffect(() => {
    if (staff === "Yes") {
      axios
        .get("/api/search-history", {
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          })
        .then((response) => {
          const dataResponse = response.data.map((subscribers, index) => ({
            ...subscribers,
            rowNumber: index + 1,
          }));
          setSearchHistory(dataResponse);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/search-history", {
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          })
        .then((response) => {
          const dataResponse = response.data
            .filter(
              (subscribers) => subscribers["subscriber_name"] === subscribername
            )
            .map((subscribers, index) => ({
              ...subscribers,
              rowNumber: index + 1,
            }));
          setSearchHistory(dataResponse);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [subscribername, staff]);

  useEffect(() => {
    if (staff === "Yes") {
      axios
        .get("/api/successful-search", {
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          })
        .then((response) => {
          const dataResponse = response.data.map((subscribers, index) => ({
            ...subscribers,
            rowNumber: index + 1,
          }));
          setCountSuccessfulSearch(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/successful-search", {
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          })
        .then((response) => {
          const dataResponse = response.data
            .filter(
              (subscribers) => subscribers["subscriber_name"] === subscribername
            )
            .map((subscribers, index) => ({
              ...subscribers,
              rowNumber: index + 1,
            }));
            setCountSuccessfulSearch(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [subscribername, staff]);


  useEffect(() => {
    if (staff === "Yes") {
      axios
        .get("/api/failed-search", {
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          })
        .then((response) => {
          const dataResponse = response.data.map((subscribers, index) => ({
            ...subscribers,
            rowNumber: index + 1,
          }));
          setCountFailedSearch(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/failed-search", {
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          })
        .then((response) => {
          const dataResponse = response.data
            .filter(
              (subscribers) => subscribers["subscriber_name"] === subscribername
            )
            .map((subscribers, index) => ({
              ...subscribers,
              rowNumber: index + 1,
            }));
            setCountFailedSearch(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [subscribername, staff]);

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.2,
    },
    {
      field: "phone_number_identifier",
      headerName: "Phone Number Identifier",
      flex: 1.3,
    },
    {
      field: "name_identifier",
      headerName: "Name Identifier",
      flex: 1.3,
    },
    {
      field: "processed",
      headerName: "Processed",
      flex: 1.3,
    },
    {
      field: "username",
      headerName: "Username",
      flex: 0.7,
    },
    {
      field: "subscriber_name",
      headerName: "Subscriber Name",
      flex: 1.5,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.7,
      renderCell: (params) => {
        const status = params.value;
        const cellClassName = status === "SUCCESS" ? "green-bg" : "red-bg";
        return <div className={cellClassName}>{status}</div>;
      },
    },
  ];

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="NAME LOOKUP HISTORY" subtitle="Phone numbers verification search list" />
          </Box>

          {/* GRID & CHARTS  */}
          <Box
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="140px"
            gap="20px"
          >
            {staff === "No" ? (
              <>
                <Box
                  gridColumn="span 6"
                  backgroundColor="#f2f0f0"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <StatBox
                    title={countSuccessfulSearch}
                    subtitle="Successful Searches"
                    icon={
                      <PersonSearchOutlinedIcon
                        sx={{ color: "#70d8bd", fontSize: "26px" }}
                      />
                    }
                  />
                </Box>
                <Box
                  gridColumn="span 6"
                  backgroundColor="#f2f0f0"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <StatBox
                    title={countFailedSearch}
                    subtitle="Failed Searches"
                    icon={
                      <SearchOffOutlinedIcon
                        sx={{ color: "#70d8bd", fontSize: "26px" }}
                      />
                    }
                  />
                </Box>
              </>
            ) : (
              <>
                <Box
                  gridColumn="span 6"
                  backgroundColor="#f2f0f0"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <StatBox
                    title={countSuccessfulSearch}
                    subtitle="Successful Searches"
                    icon={
                      <PersonSearchOutlinedIcon
                        sx={{ color: "#70d8bd", fontSize: "26px" }}
                      />
                    }
                  />
                </Box>
                <Box
                  gridColumn="span 6"
                  backgroundColor="#f2f0f0"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <StatBox
                    title={countFailedSearch}
                    subtitle="Failed Searches"
                    icon={
                      <SearchOffOutlinedIcon
                        sx={{ color: "#70d8bd", fontSize: "26px" }}
                      />
                    }
                  />
                </Box>
              </>
            )}
          </Box>

          {/* SUBSCRIBERS TABLE  */}
          <Box
            m="40px 0 0 0"
            height="100vh"
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .name-column--cell": {
                color: "#2e7c67",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#bbbbbb",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: "#f2f0f0",
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "none",
                backgroundColor: "#bbbbbb",
              },
              "& .MuiCheckbox-root": {
                color: `${"#1e5245"} !important`,
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${"#525252"} !important`,
              },
            }}
          >
            <DataGrid
              rows={searchHistory || []}
              columns={columns}
              components={{ Toolbar: GridToolbar }}
            />
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default SearchHistory;